import React from 'react';
import { Link } from 'react-router-dom';

const jumps = [
  { href: '#services', label: 'The services' },
  { href: '#ways', label: 'Ongoing or project' },
  { href: '#businesses', label: 'For businesses' },
  { href: '#agencies', label: 'For agencies' }
];

const ServicesHero = () => {
  return (
    <section className="bg-[#174C3C] pt-24 pb-16 text-white lg:pt-32 lg:pb-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-[minmax(0,1.25fr)_minmax(16rem,0.75fr)] lg:items-start">
          <div>
            <div className="mb-6 text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
              Services
            </div>
            <h1 className="text-5xl leading-[1.05] text-white sm:text-6xl lg:text-7xl">
              One technical partner for your website and everything that supports it.
            </h1>
            <p className="mt-8 max-w-2xl text-xl leading-relaxed text-white/75 sm:text-2xl">
              Website management, email, hosting, support, and project work.
              Start with one problem, or bring the wider setup under one
              relationship.
            </p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Link
                to="/digital-review"
                className="home-button-on-dark bg-white"
              >
                Tell Us What You Need
              </Link>
              <a
                href="#services"
                className="home-button-on-dark-secondary"
              >
                Browse the services
              </a>
            </div>
          </div>

          <nav
            aria-label="On this page"
            className="border-t border-white/20 pt-6 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0"
          >
            <div className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
              On this page
            </div>
            <div className="flex flex-col gap-4">
              {jumps.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-lg font-bold text-white/90 underline decoration-[#D7B77A] decoration-2 underline-offset-4 transition-colors hover:text-[#D7B77A]"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </nav>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
